import { createSlice } from "@reduxjs/toolkit";
import {
  PartnershipData,
  PartnershipInitialStatus,
} from "../../../../../types/webCms/aboutUs/partnerShip";
import {
  DeletePartnetShipImageAync,
  getAllPartnerShipAsync,
  updatePartnerShipAsync,
} from "./partnerShipApi";

const initialState: PartnershipInitialStatus<PartnershipData> = {
  loading: false,
  manageLoading: false,
  partnershipDataList: [],
  countPartnershipData: 0,
};

const partnershipSlice = createSlice({
  name: "admin-partnership",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllPartnerShipAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllPartnerShipAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.partnershipDataList = action.payload.data;
        state.countPartnershipData = action.payload.length;
      })
      .addCase(getAllPartnerShipAsync.rejected, (state) => {
        state.loading = false;
        state.partnershipDataList = [];
        state.countPartnershipData = 0;
      });

    // update
    builder
      .addCase(updatePartnerShipAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updatePartnerShipAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updatePartnerShipAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // delete
    builder
      .addCase(DeletePartnetShipImageAync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(DeletePartnetShipImageAync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(DeletePartnetShipImageAync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default partnershipSlice;
